import { ColorThemeService } from '../../../../navigation/services/color-theme-service';
import { PackagingUnitDto } from 'src/app/data-transfer/entities/packaging-unit-entities/packaging-unit-dto';
import { MAIN_BODY_DIFFERS_FROM_PACKAGING_TYPE, PackagingUnitTypeService } from '../../../../navigation/services/packaging-unit-type-service';
import { AuthService } from '../../../../services/auth-service';
import { CreateUpdateHandler } from '../../../../services/packaging-services/create-update-handler';
import { ComponentCanDeactivate } from '../../../../services/unsaved-changes-guard';
import { Component, OnInit, HostListener, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { PackagingUnitNavigationService } from 'src/app/navigation/services/navigation-services/packaging-unit-navigation.service';
import {
  CreateUpdatePackagingPartComponent,
  READ_ONLY_SUB_REQUEST_STATUSES_FOR_RECEIVER,
} from '../../../shared-components/parent-components/create-update-packaging-part/create-update-packaging-part.component';
import { FileApiService } from 'src/app/data-transfer/services/file-api-service';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { VersionDto } from 'src/app/data-transfer/entities/version-dto';
import { PackagingPartTypeDto } from 'src/app/data-transfer/entities/packaging-part-type-dto';
import { PackagingUnitApiService } from 'src/app/data-transfer/services/packaging-unit-api-service';
import { COMPONENT_CATEGORIES, ComponentTypeService } from 'src/app/navigation/services/component-type-service';
import { PackagingComponentTypesEnum } from 'src/app/model/packaging-component-types-enum';
import { PackagingUnitHtmlTemplateComponent } from '../common/packaging-unit-html-template/packaging-unit-html-template.component';
import { PackagingComponentEntryDto } from 'src/app/data-transfer/entities/component-entities/packaging-component-entry-dto';
import { PackagingPart } from 'src/app/model/packaging-part-enum';
import { DictionaryHandler, NullableDictionary, TriStateDictionary } from 'src/app/model/dictionary';
import { MainBodyEntryDto } from 'src/app/data-transfer/entities/component-entities/main-body-entry-dto';
import { ClosureEntryDto } from 'src/app/data-transfer/entities/component-entities/closure-entry-dto';
import { InlayEntryDto } from 'src/app/data-transfer/entities/component-entities/inlay-entry-dto';
import { PackagingAidEntryDto } from 'src/app/data-transfer/entities/component-entities/packaging-aid-entry-dto';
import { LabelEntryDto } from 'src/app/data-transfer/entities/component-entities/label-entry-dto';
import { SleeveEntryDto } from 'src/app/data-transfer/entities/component-entities/sleeve-entry-dto';
import { InMoldLabelEntryDto } from 'src/app/data-transfer/entities/component-entities/in-mold-label-entry-dto';
import { AdditionalPackagingComponent } from 'src/app/components/shared-components/additional-packaging/additional-packaging.component';
import { DecorationEntryDto } from 'src/app/data-transfer/entities/component-entities/decoration-entry-dto';
import { CoreDataUpdateService } from 'src/app/data-transfer/services/core-data-update-api-service';
import { DataExchangeRequestApiService } from 'src/app/data-transfer/services/data-exchange-request-api-service';
import { DirectoryApiService } from 'src/app/data-transfer/services/directory-api-service';
import { TranslocoService } from '@jsverse/transloco';
import { PathResolveService } from 'src/app/services/path-resolve.service';
import { SimpleAlertDialogComponent, SimpleDialogData } from 'src/app/components/dialogs/simple-alert-dialog/simple-alert-dialog.component';
import { getDialogConfig } from 'src/app/util/dialog-util';
import {
  CreateDataExchangeRequestDialogComponent,
  CreateDataExchangeRequestDialogData,
} from 'src/app/components/directory-tree/dialogs/create-data-exchange-request-dialog/create-data-exchange-request-dialog.component';
import { DialogActions } from 'src/app/model/dictionary';
import { DataExchangeSubRequestInfoDto } from 'src/app/data-transfer/entities/data-exchange-request-entities/data-exchange-sub-request-info-dto';
import { DataExchangeRequestDto } from 'src/app/data-transfer/entities/data-exchange-request-entities/data-exchange-request-dto';
import { DataExchangeRequestStatusDto } from 'src/app/data-transfer/entities/data-exchange-request-entities/data-exchange-request-status-dto';
import { UpdateDataExchangeRequestStatusDto } from 'src/app/data-transfer/entities/data-exchange-request-entities/update-data-exchange-request-status-dto';
import {
  SubRequestCommentsDialogComponent,
  SubRequestCommentsDialogData,
  SubRequestCommentsDialogResult,
} from 'src/app/components/dialogs/sub-request-comments-dialog/sub-request-comments-dialog.component';
import { PpwrDocumentsComponent } from 'src/app/components/shared-components/ppwr-documents/ppwr-documents.component';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-create-update-packaging-unit',
  templateUrl: './create-update-packaging-unit.component.html',
  styleUrls: ['./create-update-packaging-unit.component.scss'],
})
export class CreateUpdatePackagingUnitComponent extends CreateUpdatePackagingPartComponent implements OnInit, ComponentCanDeactivate {
  @ViewChild(PpwrDocumentsComponent) private ppwrDocumentsComponent!: PpwrDocumentsComponent;

  @ViewChild('mainBody') mainBodyDirective!: AdditionalPackagingComponent;
  @ViewChild('closure') closureDirective!: AdditionalPackagingComponent;
  @ViewChild('decoration') decorationDirective!: AdditionalPackagingComponent;
  @ViewChild('inlay') inlayDirective!: AdditionalPackagingComponent;
  @ViewChild('packAid') packAidDirective!: AdditionalPackagingComponent;

  componentsCount!: Record<number, number>;

  packagingUnitForm!: FormGroup;
  packagingUnit = new PackagingUnitDto();
  isDataExchangeSubRequest = false;
  subRequestInfo: DataExchangeSubRequestInfoDto | null = null;
  isInOngoingDataExchange: DataExchangeRequestDto[] = [];
  readonly dataExchangeRequestsPath = '/' + PathResolveService.getDataExchangeRequestsPath(true);
  readonly DataExchangeRequestStatusDto = DataExchangeRequestStatusDto;

  packagingUnitTypeImageSource = '';
  mainBodyTypeImageSource = '';

  packagingUnitType?: PackagingPartTypeDto;
  componentTypes = PackagingComponentTypesEnum;

  fillingVolume: number | undefined;

  onSubRequestCommentAdded(text: string): void {
    if (!this.subRequestInfo) {
      return;
    }
    const subRequestId = this.subRequestInfo.subRequest.id;
    this.dataExchangeApiService.addSubRequestComment(subRequestId, text).subscribe({
      next: () => {
        this.dataExchangeApiService.getSubRequestInfo(subRequestId, true).subscribe({
          next: info => {
            this.subRequestInfo = info;
          },
        });
      },
    });
  }

  packagingLevelOptions: NullableDictionary[];
  isPackagingPartOfProductDictionary: TriStateDictionary[];
  isMultiUseDictionary: TriStateDictionary[];
  nullPlaceholder: string = '';

  get primaryPackagingControl(): FormControl {
    return this.packagingUnitForm.controls.primaryPackagingControl as FormControl;
  }

  constructor(
    protected createUpdateHandler: CreateUpdateHandler,
    protected dialog: MatDialog,
    protected packagingUnitApiService: PackagingUnitApiService,
    protected authService: AuthService,
    protected colorThemeService: ColorThemeService,
    protected packagingUnitTypeService: PackagingUnitTypeService,
    protected componentTypeService: ComponentTypeService,
    protected cdr: ChangeDetectorRef,
    protected route: ActivatedRoute,
    protected spinner: NgxSpinnerService,
    protected fileApiService: FileApiService,
    protected coreDataUpdateService: CoreDataUpdateService,
    private formBuilder: FormBuilder,
    private navigationService: PackagingUnitNavigationService,
    private dictionaryHandler: DictionaryHandler,
    private router: Router,
    private dataExchangeApiService: DataExchangeRequestApiService,
    private directoryApiService: DirectoryApiService,
    private translocoService: TranslocoService
  ) {
    super(createUpdateHandler, dialog, colorThemeService, authService, cdr, route, spinner, fileApiService, coreDataUpdateService);

    this.packagingLevelOptions = this.dictionaryHandler.getTransformedCoreDataDictionary(this.coreDataUpdateService.allPackagingLevels, true);
    this.isMultiUseDictionary = this.dictionaryHandler.getIsMultiUseDictionary();
    this.isPackagingPartOfProductDictionary = this.dictionaryHandler.getPackagingPartOfDictionary();
    for (const option of this.packagingLevelOptions) {
      if (option.key === null) {
        this.nullPlaceholder = option.value;
      }
    }
  }

  private setComponentsCount() {
    this.componentsCount = {
      [PackagingComponentTypesEnum.Closure]: this.packagingUnit.closures.length,
      [PackagingComponentTypesEnum.Decoration]: this.packagingUnit.labels.length + this.packagingUnit.sleeves.length + this.packagingUnit.inMoldLabels.length,
      [PackagingComponentTypesEnum.Inlay]: this.packagingUnit.inlays.length,
      [PackagingComponentTypesEnum.PackagingAid]: this.packagingUnit.packagingAids.length,
    };
  }

  ngOnInit() {
    this.routeParamsSubscription = this.route.params.subscribe(params => {
      if (params.candidateId) {
        this.isPreview = true;
      }
    });
    this.routeDataSubscription = this.route.data.subscribe(data => {
      if (data.packagingUnit) {
        this.packagingUnit = data.packagingUnit;
        this.relevantAnalysisTypes.ccRelevant = data.packagingUnit.isCCRelevant;
        this.relevantAnalysisTypes.lcaRelevant = data.packagingUnit.isLCARelevant;
        this.relevantAnalysisTypes.ppwrRelevant = data.packagingUnit.isPPWRRelevant;
        this.relevantAnalysisTypes.recyclingRelevant = data.packagingUnit.isRecyclabilityRelevant;
        this.currentDirectoryId = data.packagingUnit.directoryId;
        if (data.packagingUnit.mainBody) {
          this.setPackagingUnitTypeFromId(data.packagingUnit.mainBody.underlyingComponent.packagingComponentSubtypeId);
        }
        if (this.packagingUnitForm) {
          window.location.reload();
          this.initPackaging();
        }
        this.selectedTags = this.allTags.filter(tag => this.packagingUnit.associatedTagIdentifiers.includes(tag.id ?? -1) ?? false);
      } else if (data.dataExchangeRequest) {
        this.packagingUnit = data.dataExchangeRequest.packagingUnit;
        this.subRequestInfo = data.dataExchangeRequest.subRequestInfo;
        this.relevantAnalysisTypes.ccRelevant = data.dataExchangeRequest.packagingUnit.isCCRelevant;
        this.relevantAnalysisTypes.lcaRelevant = data.dataExchangeRequest.packagingUnit.isLCARelevant;
        this.relevantAnalysisTypes.ppwrRelevant = data.dataExchangeRequest.packagingUnit.isPPWRRelevant;
        this.relevantAnalysisTypes.recyclingRelevant = data.dataExchangeRequest.packagingUnit.isRecyclabilityRelevant;
        this.currentDirectoryId = data.dataExchangeRequest.packagingUnit.directoryId;
        if (data.dataExchangeRequest.packagingUnit.mainBody) {
          this.setPackagingUnitTypeFromId(data.dataExchangeRequest.packagingUnit.mainBody.underlyingComponent.packagingComponentSubtypeId);
        }
        if (this.packagingUnitForm) {
          window.location.reload();
          this.initPackaging();
        }
        this.selectedTags = this.allTags.filter(tag => this.packagingUnit.associatedTagIdentifiers.includes(tag.id ?? -1) ?? false);
      } else {
        this.packagingUnit.mainBody = undefined;
      }
      if (data.permissions) {
        this.permissions = data.permissions;
        this.isEditPermitted = this.permissions?.write ?? true;
      }
      if (data.isDataExchangeSubRequest) {
        this.isDataExchangeSubRequest = true;
        if (!data.permissions) {
          this.packagingUnitApiService.getPackagingUnitPermissions(this.packagingUnit.id ?? -1).subscribe(permissions => {
            this.permissions = permissions;
            if (this.subRequestInfo?.isReceiver && READ_ONLY_SUB_REQUEST_STATUSES_FOR_RECEIVER.includes(this.subRequestInfo?.subRequest?.status ?? -1)) {
              this.isEditPermitted = false;
            } else {
              this.isEditPermitted = this.permissions?.write ?? true;
            }

            this.disableFormIfRequired(this.packagingUnitForm);
          });
        }
      }
      if (data.isInOngoingDataExchange) {
        this.isInOngoingDataExchange = data.isInOngoingDataExchange;
        if (this.isInOngoingDataExchange.length > 0 && this.packagingUnit.isCurrentVersion) {
          const firstRequest = this.isInOngoingDataExchange[0];
          const subRequest = firstRequest.subRequests?.find(sr => sr.packagingUnitInfo?.id === this.packagingUnit.id);
          const path = subRequest ? '/' + PathResolveService.getDataExchangeRequestPackagingUnitPath(true, subRequest.id) : this.dataExchangeRequestsPath;
          this.router.navigateByUrl(path);
          return;
        }
      }
      this.setComponentsCount();
      this.packagingUnitForm = this.getFormGroup();
      this.setPackagingType(this.packagingUnitForm.controls.mainBodyControl.value[0]?.underlyingComponent.packagingComponentSubtypeId);
      this.initPackaging();
    });
  }

  setPackagingType(packagingTypeId: number) {
    if (packagingTypeId != null) {
      this.setPackagingUnitTypeFromId(packagingTypeId);
    } else {
      this.packagingUnitType = undefined;
    }
    this.packagingUnitTypeImageSource = this.packagingUnitTypeService.getPackagingUnitTypeImage(packagingTypeId);
  }

  setTags() {
    this.packagingUnit.associatedTagIdentifiers = this.selectedTags.map(tag => tag.id ?? -1);
    this.cdr.detectChanges();
  }

  private getFormGroup(): FormGroup {
    return this.formBuilder.group({
      newVersionName: [''],
      primaryPackagingControl: [this.packagingUnit],
      mainBodyControl: this.packagingUnit.mainBody ? this.formBuilder.control([this.packagingUnit.mainBody]) : this.formBuilder.control([]),
      closuresControl: this.formBuilder.control(this.packagingUnit.closures),
      decorationsControl: this.formBuilder.control(this.packagingUnit.sleeves.concat(this.packagingUnit.labels).concat(this.packagingUnit.inMoldLabels)),
      inlaysControl: this.formBuilder.control(this.packagingUnit.inlays),
      packagingAidsControl: this.formBuilder.control(this.packagingUnit.packagingAids),
      packagingLevel: [this.packagingUnit.packagingLevel ?? null],
      isPackagingPartOfProduct: [this.packagingUnit.isPackagingPartOfProduct ?? null],
      isMultiUsePackaging: [this.packagingUnit.isMultiUsePackaging ?? null],
    });
  }

  updateMainBodyVolume(volume: number) {
    this.fillingVolume = volume;
  }

  updateComponentCount(count: { key: number; count: number }) {
    this.componentsCount[count.key] = count.count;
  }

  private initPackaging() {
    this.isHistory = this.packagingUnit.id != null && !this.packagingUnit.isCurrentVersion;
    this.isTracked = this.packagingUnit.hasExternalTracking ?? false;
    const lockFunction = (packagingUnitId: number) => this.packagingUnitApiService.lockPackagingUnit(packagingUnitId, true);
    this.setUpLockAndHeartbeat(this.packagingUnitForm, lockFunction, this.packagingUnit?.id);
    super.disableFormIfRequired(this.packagingUnitForm);
    this.historyVersions = [
      {
        id: this.packagingUnit.id,
        versionNumber: this.packagingUnit.version,
        versionName: this.packagingUnit.versionName,
        creationTimestamp: this.packagingUnit.creationTimestamp,
        isCurrentVersion: this.packagingUnit.isCurrentVersion,
      },
    ];
  }

  loadHistoryVersions() {
    const versionsFunction = (packagingUnitId: number) => this.packagingUnitApiService.getPackagingUnitHistoryVersions(packagingUnitId);
    super.loadHistoryVersions(this.packagingUnit.id, versionsFunction);
  }

  onHistoryVersionChange(version: number) {
    const navigationFunction = (packagingUnitId: number, packagingUnitVersion?: number) => {
      if (packagingUnitVersion == null && this.isInOngoingDataExchange.length > 0) {
        const firstRequest = this.isInOngoingDataExchange[0];
        const subRequest = firstRequest.subRequests?.find(sr => sr.packagingUnitInfo?.id === packagingUnitId);
        const path = subRequest ? '/' + PathResolveService.getDataExchangeRequestPackagingUnitPath(true, subRequest.id) : this.dataExchangeRequestsPath;
        this.router.navigateByUrl(path);
      } else {
        this.navigationService.navigateToPackagingUnit(packagingUnitId, packagingUnitVersion);
      }
    };
    super.onHistoryVersionChange(version, navigationFunction);
  }

  editVersionName(packagingUnit: VersionDto) {
    const renameFunction = (id: number, version: number, name: string) => this.packagingUnitApiService.renamePackagingUnit(id, version, name, true);
    super.editVersionName(packagingUnit, this.packagingUnit, renameFunction);
  }

  getComponentImage(componentType: PackagingComponentTypesEnum, packagingTypeId?: number) {
    if (componentType === PackagingComponentTypesEnum.MainBody) {
      return MAIN_BODY_DIFFERS_FROM_PACKAGING_TYPE.includes(packagingTypeId ?? -1)
        ? this.packagingUnitTypeService.getMainBodyTypeImage(packagingTypeId)
        : this.packagingUnitTypeService.getPackagingUnitTypeImage(packagingTypeId);
    } else {
      return this.componentTypeService.getComponentTypeImage(componentType, this.isDarkTheme);
    }
  }

  private setPackagingUnitTypeFromId(packagingUnitTypeId: number) {
    this.packagingUnitType = this.packagingUnitTypeService.getPackagingUnitTypeDtoFromId(packagingUnitTypeId);
  }

  async releaseComponent() {
    const releaseFunction = (packagingUnitId: number) => this.packagingUnitApiService.releasePackagingUnit(packagingUnitId, true);
    super.releaseComponent(this.packagingUnit.id, releaseFunction);
  }

  /**
   * If no changes were made, user can navigate away from page
   */
  @HostListener('window:beforeunload')
  canDeactivate(): boolean {
    return (this.packagingUnitForm?.pristine && !this.filesEdited)
      || this.isPreview || this.isUserValidator || this.isUserAdmin || this.isHistory;
  }

  async onSubmit() {
    this.submitted = true;
    this.packagingUnitForm.updateValueAndValidity();
    this.packagingUnitForm.markAllAsTouched();
    if (this.packagingUnitForm.invalid) {
      super.openFormInvalidDialog();
    } else {
      const dirId = this.currentDirectoryId != null ? this.currentDirectoryId : await super.selectDirectory();
      if (dirId == null) {
        return;
      }
      this.addNewPackagingUnit(dirId);
    }
  }

  async onFinishRequest() {
    this.submitted = true;
    this.packagingUnitForm.updateValueAndValidity();
    this.packagingUnitForm.markAllAsTouched();
    if (this.packagingUnitForm.invalid) {
      super.openFormInvalidDialog();
      return;
    }
    await this.buildPackagingUnitDto();
    const subRequestId = +this.route.snapshot.params['id'];
    this.spinner.show();
    this.dataExchangeApiService.updateSubRequestPackagingUnit(subRequestId, this.packagingUnit, true, true).subscribe({
      next: _ => {
        this.spinner.hide();
        Object.keys(this.packagingUnitForm.controls).forEach(control => {
          this.packagingUnitForm.controls[control].markAsPristine();
        });
        this.packagingUnitForm.markAsPristine();
        this.filesEdited = false;
        this.router.navigateByUrl('/' + PathResolveService.getDataExchangeRequestsPath(true) + '?tab=1');
      },
      error: e => {
        this.spinner.hide();
        const dialogData = this.createUpdateHandler.getFailureDialogData(e);
        this.dialog.open(SimpleAlertDialogComponent, getDialogConfig(dialogData, '400px'));
      },
    });
  }

  onApproveSubRequest(): void {
    if (!this.subRequestInfo) {
      return;
    }
    const dto: UpdateDataExchangeRequestStatusDto = { status: DataExchangeRequestStatusDto.Closed };
    this.dataExchangeApiService.updateSubRequestStatus(this.subRequestInfo.subRequest.id, dto, true).subscribe({
      next: () => this.router.navigateByUrl('/' + PathResolveService.getDataExchangeRequestsPath(true)),
    });
  }

  onReopenSubRequest(): void {
    if (!this.subRequestInfo) {
      return;
    }
    const title = this.translocoService.translate('dataManagement.dataExchangeRequests.comments.subRequestTitle');
    const data: SubRequestCommentsDialogData = {
      comments: this.subRequestInfo.subRequest.comments,
      title,
      allowOptionalComment: true,
      confirmButtonTranslationKey: 'dataManagement.dataExchangeRequests.buttons.reopenSubRequest',
    };
    const dialogRef = this.dialog.open(SubRequestCommentsDialogComponent, getDialogConfig(data, '500px'));
    dialogRef.afterClosed().subscribe((result: SubRequestCommentsDialogResult | undefined) => {
      if (!result?.confirmed) {
        return;
      }

      const dto: UpdateDataExchangeRequestStatusDto = { status: DataExchangeRequestStatusDto.ReOpened };
      this.dataExchangeApiService.updateSubRequestStatus(this.subRequestInfo!.subRequest.id, dto, true).subscribe({
        next: () => {
          if (result.comment) {
            this.dataExchangeApiService.addSubRequestComment(this.subRequestInfo!.subRequest.id, result.comment, true).subscribe({
              next: () => this.router.navigateByUrl('/' + PathResolveService.getDataExchangeRequestsPath(true)),
            });
            return;
          }

          this.router.navigateByUrl('/' + PathResolveService.getDataExchangeRequestsPath(true));
        },
      });
    });
  }

  async createDataExchangeRequest(): Promise<void> {
    if (this.packagingUnit.id == null) {
      return;
    }
    const securityPrincipals = await this.directoryApiService.getExternalSecurityPrincipals().toPromise();
    if (!securityPrincipals) {
      return;
    }
    const dialogData: CreateDataExchangeRequestDialogData = {
      allPrincipals: securityPrincipals,
      packagingUnitIds: [this.packagingUnit.id],
    };
    const dialogRef = this.dialog.open(CreateDataExchangeRequestDialogComponent, getDialogConfig(dialogData, '50%'));
    dialogRef.afterClosed().subscribe(result => {
      if (!result || result.event === DialogActions.REJECT) {
        return;
      }
      this.dataExchangeApiService.createDataExchangeRequest(result.dto, true).subscribe({
        next: _ => {
          const data: SimpleDialogData = {
            title: this.translocoService.translate('common.text.success'),
            messages: [this.translocoService.translate('dataManagement.directory.dialog.dataExchangeRequest.createSuccess')],
            icon: 'info',
          };
          this.dialog.open(SimpleAlertDialogComponent, getDialogConfig(data, '500px'));
        },
        error: _ => {
          const data: SimpleDialogData = {
            title: this.translocoService.translate('common.text.error'),
            messages: [this.translocoService.translate('dataManagement.directory.dialog.dataExchangeRequest.createError')],
            icon: 'error',
          };
          this.dialog.open(SimpleAlertDialogComponent, getDialogConfig(data, '500px'));
        },
      });
    });
  }

  isLabel = (subtypeId: number) => {
    return this.componentTypeService.isDecorationOfTypeLabel(subtypeId);
  };
  isSleeve = (subtypeId: number) => {
    return this.componentTypeService.isDecorationOfTypeSleeve(subtypeId);
  };
  isInMold = (subtypeId: number) => {
    return this.componentTypeService.isDecorationOfTypeInMold(subtypeId);
  };

  private async buildPackagingUnitDto(directoryId?: number): Promise<void> {
    if (directoryId != null) {
      this.packagingUnit.directoryId = directoryId;
    }

    PackagingUnitHtmlTemplateComponent.updatePackagingUnit((this.packagingUnitForm.controls.primaryPackagingControl as FormGroup).getRawValue(), this.packagingUnit);
    this.packagingUnit.versionName = this.packagingUnitForm.value?.newVersionName ?? null;

    this.packagingUnit.mainBody = this.mainBodyDirective.getComponentEntries()[0] as MainBodyEntryDto;

    this.packagingUnit.closures = this.closureDirective.getComponentEntries() as ClosureEntryDto[];
    const decorations = this.decorationDirective.getComponentEntries() as DecorationEntryDto[];
    const labels = decorations.filter(x => this.isLabel(x.underlyingComponent.packagingComponentSubtypeId)) as LabelEntryDto[];
    const sleeves = decorations.filter(x => this.isSleeve(x.underlyingComponent.packagingComponentSubtypeId)) as SleeveEntryDto[];
    const inMolds = decorations.filter(x => this.isInMold(x.underlyingComponent.packagingComponentSubtypeId)) as InMoldLabelEntryDto[];
    this.packagingUnit.labels = labels;
    this.packagingUnit.sleeves = sleeves;
    this.packagingUnit.inMoldLabels = inMolds;
    this.packagingUnit.inlays = this.inlayDirective.getComponentEntries() as InlayEntryDto[];
    this.packagingUnit.packagingAids = this.packAidDirective.getComponentEntries() as PackagingAidEntryDto[];

    this.packagingUnit.packagingLevel = this.packagingUnitForm.value?.packagingLevel ?? null;
    this.packagingUnit.isPackagingPartOfProduct = this.packagingUnitForm.value?.isPackagingPartOfProduct ?? null;
    this.packagingUnit.isMultiUsePackaging = this.packagingUnitForm.value?.isMultiUsePackaging ?? null;
    await super.updateImagesAndDocuments(this.packagingUnit);

    const ppwrFormData = this.ppwrDocumentsComponent.getNewPpwrFilesFormData();
    if (ppwrFormData.has('files')) {
      const ppwrIds = await firstValueFrom(this.fileApiService.putDocuments(ppwrFormData));
      this.ppwrDocumentsComponent.updateDocumentIdsAfterSaving(ppwrIds);
    }
  }

  private async addNewPackagingUnit(directoryId: number) {
    await this.buildPackagingUnitDto(directoryId);

    let saveFunction = (packagingItem: PackagingUnitDto) => this.packagingUnitApiService.putPackagingUnit(packagingItem);

    let navFunction = (id: number, version: number) => this.navigationService.navigateToPackagingUnit(id, version);

    if (this.isDataExchangeSubRequest) {
      const subRequestId = +this.route.snapshot.params['id'];
      saveFunction = (packagingItem: PackagingUnitDto) => this.dataExchangeApiService.updateSubRequestPackagingUnit(subRequestId, packagingItem);
      navFunction = (id: number, version: number) => {
        const path = PathResolveService.getDataExchangeRequestPackagingUnitPath(true, this.route.snapshot.params['id']);
        this.router.navigateByUrl(path);
      };
    }

    super.putPackagingItem(this.packagingUnit, this.packagingUnitForm, saveFunction, navFunction);
  }
}
